document.addEventListener('DOMContentLoaded', () => {
  const images = document.querySelectorAll('img.progressive-img');

  function loadStep(img, url) {
    return new Promise(resolve => {
      const temp = new Image();
      temp.src = url;
      temp.onload = () => {
        img.src = url;
        resolve();
      };
    });
  }

  function progressivelyLoad(img) {
    const step1 = img.getAttribute('data-step1');
    const step2 = img.getAttribute('data-step2');
    const final = img.getAttribute('data-final');

    (async () => {
      if (step1) await loadStep(img, step1);
      if (step2) await loadStep(img, step2);
      if (final) await loadStep(img, final);

      img.removeAttribute('data-step1');
      img.removeAttribute('data-step2');
      img.removeAttribute('data-final');
    })();
  }

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          progressivelyLoad(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '200px',
      threshold: 0.01
    });

    images.forEach(img => observer.observe(img));
  } else {
    images.forEach(img => progressivelyLoad(img));
  }
});